import {
    Box,
    Button,
    Text,
    Image,
    HStack,
    Switch,
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
    SliderMark,
    Input,
    VStack,
    Spinner,
} from '@chakra-ui/react';
import { InputGroup, InputRightElement } from '@chakra-ui/input';
import { useContext, useEffect, useRef } from 'react';
import UIContext from '../context/UIContext';
import { ZeroState } from './ZeroState';
import MapContext from '../context/MapContext';

export function MapSearch() {
    const {searchQuery, setSearchResults,
        setSearchQuery, searchLoading, searchResults,
        selectedSearchResult,
        setSelectedSearchResult,
        commitSelectedSearchResult } = useContext(UIContext);
    const { mapRef } = useContext(MapContext);
    const searchBar = useRef();

    useEffect(() => {
        searchBar.current.focus();
    }, []);

    let searchQueryText = undefined;
    if (searchQuery) {
        if (searchQuery.text !== null) {
            searchQueryText = searchQuery.text;
        } else if (searchQuery.position !== null) {
            searchQueryText = `${searchQuery.position.latitude.toFixed(6)}, ${searchQuery.position.longitude.toFixed(6)}`
        }
    }

    return (
        <Box w="100%" flex="0 0 auto" display="flex" justifyContent="stretch" alignItems="stretch" flexDir="column">
            <Box p="10px" w="100%">
            <InputGroup>
            <Input value={searchQueryText || ''} onChange={(e) => {
                commitSelectedSearchResult(null);
                setSearchQuery((old) => {
                    if (!old) {
                        return {
                            text: e.target.value,
                            position: null
                        }
                    }
                    if (old.position !== null) {
                        return old;
                    } else {
                        return {
                            text: e.target.value,
                            position: null
                        }
                    }
                });
            }} ref={searchBar}
            fontSize="14px"
            placeholder="Search query..." bg="white" shadow="md" borderRadius="0px" border="2px solid #0594ED"></Input>
            {searchQuery !== null && (
                
            <InputRightElement width="80px">
            <Button
                borderRadius="0px"
                h="1.75rem"
                size="sm"
                onClick={() => {
                    setSearchQuery(null);
                    setSearchResults(null);
                    commitSelectedSearchResult(null);
                }}
            >
                Clear
            </Button>
            </InputRightElement>
            )}
            </InputGroup>
            </Box>
            <Box height="0px"></Box>
            <Box flex="1" overflow="auto" p="10px" pt="0px">
            {searchLoading ? (
                <VStack mt="40px">
                    <Spinner speed="1s" thickness="3px" opacity="0.5" size="xl" />
                    <Text fontSize="16px" color="rgba(0,0,0,0.4)" fontWeight="500" mb="10px">Searching...</Text>
                </VStack>
            ) : !searchResults && (
                <ZeroState
                title="No Results"
                icon="search"
                description="Enter a search term or location."
            ></ZeroState>
            )}
            {searchResults && searchResults.results.length == 0 && (
                <ZeroState
                title="No Results"
                icon="search"
                description="No results were found. Try another search term."
            ></ZeroState>
            )}
            {searchResults && searchResults.results.map((result) => {
                if (!result.position) {
                    return null;
                }
                const {
                    id,
                    parentId,
                    layerId,
                    layerName,
                    position,
                    attributes
                } = result;

                const isSelected = selectedSearchResult && selectedSearchResult.id == id;
                return (
                    <Box border={"1px solid rgba(0,0,0,0.1)"} bg="white" p="5px" mb="10px" shadow="sm"
                        cursor="pointer"
                        key={id}
                        onClick={() => {
                            commitSelectedSearchResult(result);
                        }}
                        position="relative"
                    >
                        {isSelected && (<Box border={"2px solid #ff8800"}
                            position="absolute"
                            top="0px"
                            left="0px"
                            bottom="0px"
                            right="0px"
                        >
                            </Box>)}
                        
                        <Text></Text>
                        <Text>{attributes.objectName}</Text>
                        <Text>{layerName} ({layerId})</Text>
                        <Text pt="4px" color="rgba(0,0,0,0.4)">{parentId}, {position[0].toFixed(6)}, {position[1].toFixed(6)}</Text>
                    </Box>
                )
            })}
                
            </Box>
        </Box>
    );
}
